import React from 'react';
import 'twin.macro';

interface IconCalloutProps {
  icon: React.ReactNode;
}

const IconCallout: React.FC<IconCalloutProps> = ({ icon, children }) => (
  <div tw="flex items-center space-x-4 max-w-3xl my-16">
    <div tw="flex-shrink-0 text-blue w-24 md:(w-36)">{icon}</div>
    <div>{children}</div>
  </div>
);

export default IconCallout;
